var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{attrs:{"name":"header"}}),_c('main',[_c('fade-transition',{attrs:{"origin":"center","mode":"out-in","duration":250}},[_c('router-view')],1)],1),_c('router-view',{attrs:{"name":"footer"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }